<div class="content">

  <div class="text-left mt-5">

    <h3>Generate Bearer Token(Id Token)</h3> <br><br><br>


    <!-- <p>
      <b>Please note:</b> We are updating authentication mechanism. We will provide a mechanism in UI to generate access
      key and secret key from Optimus Dashboard. We also plan to move to auth0 soon.
    </p><br><br> -->

    <h5>Example Request</h5><br>

    <div class="card text-bg-dark mb-3">
      <div class="card-body">

     <div class="card-title">
      <button style="float: right;" *ngIf="copyButton" class="btn btn-outline-primary btn-sm" (click)="copyJsonToClipboard()">
        <i class="fa fa-clipboard" aria-hidden="true"></i>
      </button>
        
      <button style="float: right;" *ngIf="copiedButton"  class="btn btn-success btn-sm">
        Copied <i class="fa fa-check" aria-hidden="true"></i>
      </button>

     </div><br><br>
<!-- 
        <pre><code highlight-js  [lang]="'simple'" >{{ jsonData }}</code></pre> -->

        <pre><code >{{ jsonData }}</code></pre>

      </div>
    </div><br><br>


    <h5>Example Response</h5><br>


    <div class="card text-bg-light mb-3">
      <div class="card-body">

        <div class="panel panel-primary">
          <div class="tab-menu-heading">
            <ul class="nav nav-pills" role="tablist">
              <!-- Tab menu items -->
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="tab1" data-bs-toggle="tab" data-bs-target="#content1" type="button"
                  role="tab" aria-controls="content1" aria-selected="true">200</button>
              </li>
            </ul>
          </div>

          <div class="panel-body tabs-menu-body mt-4">
            <div class="tab-content">
              <!-- Tab content -->
              <div class="tab-pane fade show active" id="content1" role="tabpanel" aria-labelledby="tab1">
                <div class="card-body">
                  <pre><code [innerHTML]="tokenData"></code></pre>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>



    <br>
    <h3>API doc link:</h3><br><br>

    <ul>
      <li>
        <a routerLink="/apilist/customerAuth" target="_blank">
          <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Auth Customer</h5>
        </a>
      </li>
    </ul><br><br>



    <!-- <p><a href="http://cmw-dev-som-documentation.s3-website-us-east-1.amazonaws.com/
            #operation/customerAuth"> http://cmw-dev-som-documentation.s3-website-us-east-1.amazonaws.com/
            #operation/customerAuth</a></p><br> -->


    <h3>Authentication</h3><br>

    <p>Use IdToken generated in previous call in all subsequent calls for authorizations.</p>



  </div>


</div>